import TimerComponent from "./timer";
import "../css/sectionHeroHome.scss";
import Lottie from "react-lottie";
import * as animationData from "../assets/homeBackgroundLottie.json";

export default function Section(props) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };
  return (
    <section id="hero-section">
      <div className="hero-background">
        <Lottie options={defaultOptions} />
      </div>
      <div className="hero-section-content">
        <h1 dangerouslySetInnerHTML={{ __html: props.hero_title }} />
        <p className="font-regular">{props.content ? props.content : props.hero_paragraph}</p>
      </div>
      <TimerComponent {...props.timer} isPreFillRad={props.isPreFillRad} />
    </section>
  );
}
